import React, {useEffect, useState} from 'react'
import IStepProps from './IStepProps'
import useAppointmentTypes from '../../hooks/UseAppointmentTypes'
import usePractitioners from '../../hooks/UsePractitioners'
import IBooking from 'shared/Practices/Entities/IBooking'
import { useForm } from 'react-hook-form'
import {useAsyncAction} from "../../../../shared/Hooks/useAsyncAction";
import {PATIENT_DETAILS_STEP, CHOOSE_REASON_STEP, CALENDAR_STEP} from '../steps/Steps'

const ChooseReasonStep = ({changeStep, submitData, setProgressState, practice}: IStepProps) => {
    const showPractitionersSelect = practice?.filterByPracticioner ?? false;

    let {appointmentTypes, getAppointmentTypes} = useAppointmentTypes();
    let {practitioners, getPractitioners} = usePractitioners();
    const { register, handleSubmit, getValues, setValue, reset } = useForm<IBooking>();
    const [selectedAppointmentType, setSelectedAppointmentType] = useState<string>();

    const getAppointmentTypesAction = useAsyncAction();
    const getPractitionersAction = useAsyncAction();

    useEffect(()=>{
        getAppointmentTypesAction.trigger(()=>{
            return getAppointmentTypes();
        });
        if(showPractitionersSelect) {
            getPractitionersAction.trigger(()=>{
                return getPractitioners();
            });
        }
    },[]);

    useEffect(()=>{
        // Loaded appointment types
        if(appointmentTypes && appointmentTypes.appointmentTypes.length > 0){
            setSelectedAppointmentType(appointmentTypes.appointmentTypes[0].type);

            if(showPractitionersSelect && practitioners && practitioners.practitioners.length > 0){
                reset({
                    appointmentType: appointmentTypes.appointmentTypes[0].type,
                    practitioner: ""
                });
            } else {
                reset({appointmentType: appointmentTypes.appointmentTypes[0].type});
            }
        }
    },[appointmentTypes]);

    useEffect(()=>{
        // Loaded practitioners
        if(showPractitionersSelect && practitioners && practitioners.practitioners.length > 0){
            if(appointmentTypes && appointmentTypes.appointmentTypes.length > 0){
                reset({
                    appointmentType: appointmentTypes.appointmentTypes[0].type,
                    practitioner: ""
                });
            } else {
                reset({practitioner: ""});
            }
        }
    },[practitioners]);

    useEffect(() => {
        //Reset practitioner dropdown to anyone if a selection was already made and the selected practitioner doesn't offer the treatment now selected
        if(
            showPractitionersSelect
            && appointmentTypes && appointmentTypes.appointmentTypes.length > 0
            && practitioners && practitioners.practitioners.length > 0
        ){
            const selectedPractitionerValue = getValues("practitioner");
            if(selectedPractitionerValue !== ""){
            const selectedPractitioner = practitioners.practitioners.find(practitioner => practitioner.practitionerID === selectedPractitionerValue);
                if(selectedPractitioner && selectedPractitioner.ApptTypes.indexOf(selectedAppointmentType ?? "") === -1){
                    setValue("practitioner", "");
                }
            }
        }
    }, [selectedAppointmentType]);

    const onSubmit = data => {
        const type = appointmentTypes?.appointmentTypes.find(type => type.type === data.appointmentType);
        submitData && submitData({
            appointmentType: data.appointmentType,
            appointmentDeposit: type?.deposit ?? 0,
            practitioner: data.practitioner
        });
        changeStep && changeStep(CALENDAR_STEP)
    };

    useEffect(() => { setProgressState && setProgressState(CHOOSE_REASON_STEP); }, []);

    return (
        <div className="o-wrap +no-pad@m- c-main +fixed-header">
            <div className="u-pull-v-center@m">
                <div className="u-pad">
                    <p className="u-micro u-bold u-uppercase u-lighten">Book your appointment</p>
                    <div className="u-marg-bottom-x2">
                        <h1 className="u-delta u-marg-bottom-half">Reason for appointment</h1>
                        <p className="u-lighten">This will determine what time slots are <br/>available as early as possible.</p>
                    </div>
                    <div className="u-marg-bottom-x2">
                        <form className="c-form" onSubmit={handleSubmit(onSubmit)}>
                            <fieldset className="u-marg-bottom">
                                <label className="u-beta u-marg-bottom-half u-block" htmlFor="appointmentType">I require a</label>
                                <select {
                                    ...register('appointmentType',
                                    {
                                        onChange: (e) => {
                                            setSelectedAppointmentType(getValues("appointmentType"))
                                        },
                                        onBlur: (e) => {}
                                    })
                                } id="appointmentType">
                                    {appointmentTypes && appointmentTypes?.appointmentTypes.map((response, i) => {
                                        return (
                                            <option value={response.type} key={i}>{response.type}</option>
                                        )
                                    })}
                                </select>
                            </fieldset>
                            {showPractitionersSelect && (
                                <fieldset className="u-marg-bottom">
                                    <label className="u-beta u-marg-bottom-half u-block" htmlFor="practitioner">With</label>
                                    <select {...register('practitioner')} id="practitioner">
                                        <option value="" key={-1}>Anyone</option>
                                        {practitioners && practitioners?.practitioners.filter(
                                            (practitioner) => practitioner.ApptTypes.indexOf(selectedAppointmentType ?? '') !== -1
                                        ).map((response, i) => {
                                            return (
                                                <option
                                                    value={response.practitionerID}
                                                    key={i}
                                                >{response.practitioner}</option>
                                            )
                                        })}
                                    </select>
                                </fieldset>
                            )}
                            <button className="c-button +large +ghost u-marg-right o-flex__item" onClick={() => changeStep && changeStep(PATIENT_DETAILS_STEP)}>Back</button>
                            <input
                                type="submit"
                                value="Select a date"
                                className="c-button +large +primary o-flex__item" />
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ChooseReasonStep
